
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../config";

const initialState = {
    isLoading: false,
    platList: [],
    produitListParPlat: [],
    platListByFournisseur: [],
    platListByCategorie: [],
    platDetails: null,
};


export const addPlat = createAsyncThunk(
    "plat/addPlat",
    async ({ platData, ligneProduits }) => {
        const response = await axios.post(
            API_URL + `/api/admin/plat/addPlat`,
            { ...platData, ligneProduits, },
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json/multipart/form-data",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const editPlat = createAsyncThunk(
    "plat/editPlat",
    async ({ platId, platData, ligneProduits }) => {
        const response = await axios.put(
            API_URL + `/api/admin/plat/editPlat/${platId}`,
            { ...platData, ligneProduits, },
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json/multipart/form-data",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const deletePlat = createAsyncThunk(
    "plat/deletePlat",
    async (platId) => {
        console.log("deletePlat", "request");
        const response = await axios.delete(
            `http://localhost:5700/api/admin/plat/deletePlat/${platId}`,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const getAllPlats = createAsyncThunk(
    "plat/getAllPlats",
    async () => {
        const response = await axios.get(
            API_URL + `/api/admin/plat/getAllPlats`,
        );
        return response.data;
    }
);

export const getPlatDetails = createAsyncThunk(
    "plat/getPlatDetails",
    async (platId) => {
        console.log("getPlatDetails", "request");
        const response = await axios.get(
            API_URL + `/api/admin/plat/getPlatDetails/${platId}`,
        );
        return response.data;
    }
);

export const getProduitsParPlat = createAsyncThunk(
    "plat/getProduitsParPlat",
    async (platId) => {
        const response = await axios.get(
            API_URL + `/api/admin/plat/getProduitsParPlat/${platId}`,
        );
        return response.data;
    }
);

export const getAllPlatsByFournisseur = createAsyncThunk(
    "plat/getAllPlatsParFournisseur",
    async (fournisseurId) => {
        console.log("getAllPlatsParFournisseur", "request");
        const response = await axios.get(
            API_URL + `/api/admin/plat/getAllPlatsParFournisseur/${fournisseurId}`,
        );
        return response.data;
    }
);

export const getAllPlatsByCategorie = createAsyncThunk(
    "plat/getAllPlatsParCategorie",
    async (categorieId) => {
        console.log("getAllPlatsParCategorie", "request");
        const response = await axios.get(
            API_URL + `/api/admin/plat/getAllPlatsParCategorie/${categorieId}`,
        );
        return response.data;
    }
);


const platSlice = createSlice({
    name: "plat",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getAllPlats.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllPlats.fulfilled, (state, action) => {
                state.isLoading = false;
                state.platList = action.payload.data;
            })
            .addCase(getAllPlats.rejected, (state) => {
                state.isLoading = false;
                state.platList = [];
            })
            .addCase(getPlatDetails.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPlatDetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.platDetails = action.payload.data;
            })
            .addCase(getPlatDetails.rejected, (state) => {
                state.isLoading = false;
                state.platDetails = null;
            })
            .addCase(getProduitsParPlat.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getProduitsParPlat.fulfilled, (state, action) => {
                state.isLoading = false;
                state.produitListParPlat = action.payload.data;
            })
            .addCase(getProduitsParPlat.rejected, (state) => {
                state.isLoading = false;
                state.produitListParPlat = [];
            })
            .addCase(getAllPlatsByFournisseur.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllPlatsByFournisseur.fulfilled, (state, action) => {
                state.isLoading = false;
                state.platListByFournisseur = action.payload.data;
            })
            .addCase(getAllPlatsByFournisseur.rejected, (state) => {
                state.isLoading = false;
                state.platListByFournisseur = [];
            })
            .addCase(getAllPlatsByCategorie.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllPlatsByCategorie.fulfilled, (state, action) => {
                state.isLoading = false;
                state.platListByCategorie = action.payload.data;
            })
            .addCase(getAllPlatsByCategorie.rejected, (state) => {
                state.isLoading = false;
                state.platListByCategorie = [];
            })
    }
});

export default platSlice.reducer;